export default __webpack_public_path__ + "static/media/bg-featured-match.d83ee38c.png";